import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL} from '../../../Apiconfig';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import styles from '../Login/Loginpage.module.css'

function LoginPage() {
  const [email, setEmail] = useState(""); // Store email input
  const [password, setPassword] = useState(""); // Store password input
  const [isPasswordVisible, setIsPasswordVisible] = useState(false); // Toggle password visibility
  const [errorMessage, setErrorMessage] = useState(""); // Store error message if login fails

  // Handle input changes for email and password
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const navigate = useNavigate();

  // Handle password visibility toggle
  const handleTogglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  // Handle login form submission
  const handleLogin = async (e) => {
    e.preventDefault();

    const loginData = {
      email: email,
      password: password,
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/login.php`, loginData, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true, 
      });
      if (response.data.success) {
        console.log(response.data)
       
        console.log("Login successful!");
        const { username, email, phone } = response.data.user;
        localStorage.setItem("username", username);
        localStorage.setItem("email", email);
        localStorage.setItem("phone", phone);
        // Redirect to dashboard or other page
        // window.location.href = "/Dashboard_panel";
        navigate("/Dashboard_panel");
      } else {
        setErrorMessage(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("An error occurred during login.");
    }
  };

  return (
    <>
    <div className={styles.overlayloginbgimg}> </div>
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-lg border-0 rounded-3" style={{ width: "30rem" }}>
        <div className="card-header bg-secondry text-center py-4">
          <h2 className="fw-bold" style={{ color: "#1f2937", textDecoration: "underline" }}>Login</h2>
          <p className="mb-0">Welcome !Please log in to your account.</p>
        </div>
        <div className="card-body p-4">
          <form className="row g-3" method="post" onSubmit={handleLogin}>
            {/* Email Field */}
            <div className="col-md-12">
              <label htmlFor="email" className="form-label fw-bold">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                placeholder="Enter your email"
                required
                value={email}
                onChange={handleEmailChange}
                />
            </div>

            {/* Password Field */}
            <div className="col-md-12">
              <label htmlFor="password" className="form-label fw-bold">
                Password
              </label>
              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  className="form-control"
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  required
                  value={password}
                  onChange={handlePasswordChange}
                  />
                <span
                  className="input-group-text bg-white border"
                  onClick={handleTogglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                  >
                  <i
                    className={`fa ${isPasswordVisible ? "fa-eye-slash" : "fa-eye"}`}
                    aria-hidden="true"
                    ></i>
                </span>
              </div>
            </div>

            {/* Error Message */}
            {errorMessage && (
              <div className="col-12 text-danger text-center">{errorMessage}</div>
            )}

            {/* Submit Button */}
            <div className="col-12 text-center">
              <button
                type="submit"
                className={styles.loginButton}
                id="btn"
                >
                Login
              </button>
            </div>

            {/* Links */}
            <div className="col-12 text-center">
              <p className="my-2">
                Don't have an account?{" "}
                <Link to={'/Sign_up'}  className="text-secondary fw-bold">
                  Register here
                </Link>
              </p>
              {/* <p>
                Forgot your password?{" "}
                <Link to={'/'} className="text-primary fw-bold">
                Reset it here
                </Link>
                </p> */}
            </div>
          </form>
        </div>
      </div>
    </div>
                </>
  );
}

export default LoginPage;
